export const borderStyles = {
    none: 'none',
    solid: 'solid',
};
export const borderWidths = {
    none: '0px',
    sm: '1px',
    md: '2px',
};
//# sourceMappingURL=borders.js.map